export default __webpack_public_path__ + "static/media/manager-m.6c9ce094.png";